var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReact1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ca_rd",
    "data-name": "icon-ca rd",
    transform: "translate(0 -3397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 56,
    height: 56,
    transform: "translate(0 3397)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-chart-set-theory",
    transform: "translate(11.044 3396.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67441",
    "data-name": "Group 67441",
    transform: "translate(0.13 12.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80500",
    "data-name": "Path 80500",
    d: "M28.049,23.818v-.1a11.093,11.093,0,1,0-22.186,0v.1A11.093,11.093,0,0,0,16.587,43.24q.187-.1.369-.213a11.093,11.093,0,0,0,11.462-19Q28.236,23.921,28.049,23.818ZM16.956,39.626a8.311,8.311,0,0,1-2.707-5.143,11.129,11.129,0,0,0,5.408,0,8.311,8.311,0,0,1-2.7,5.136Zm0-7.589a8.3,8.3,0,0,1-2.578-.409,8.332,8.332,0,0,1,2.578-4.4,8.332,8.332,0,0,1,2.578,4.4,8.3,8.3,0,0,1-2.578.409Zm-5.094-1.747a8.332,8.332,0,0,1-3.03-4.77,8.32,8.32,0,0,1,5.7.2,11.1,11.1,0,0,0-2.673,4.569Zm7.515-4.576a8.32,8.32,0,0,1,5.7-.2,8.333,8.333,0,0,1-3.03,4.777A11.1,11.1,0,0,0,19.377,25.714ZM16.956,15.4a8.332,8.332,0,0,1,8.253,7.267,11.093,11.093,0,0,0-8.253,1.155A11.093,11.093,0,0,0,8.7,22.665,8.332,8.332,0,0,1,16.956,15.4ZM3.09,33.423a8.311,8.311,0,0,1,3.225-6.572,11.142,11.142,0,0,0,5.1,6.471v.1a11.057,11.057,0,0,0,3.125,7.71A8.32,8.32,0,0,1,3.09,33.423ZM22.5,41.743a8.282,8.282,0,0,1-3.125-.61,11.057,11.057,0,0,0,3.125-7.71v-.1a11.142,11.142,0,0,0,5.1-6.471,8.32,8.32,0,0,1-5.1,14.892Z",
    transform: "translate(-0.13 -12.624)",
    fill: "#12784a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact1);
export default __webpack_public_path__ + "static/media/react1.01941f38a0fd6f8c6b7c1665b91a4511.svg";
export { ForwardRef as ReactComponent };